<template>
  <div class="login">
    <Loading v-show="loading"></Loading>
    <div class="select-os">
        <input type="radio" id="japanese" name="launguage" v-model="style" value="0" class="japanese" checked>
        <label for="japanese">
            日本語
        </label>
        <input type="radio" id="english" name="launguage" v-model="style" value="1" class="english">
        <label for="english">
            English
        </label>
    </div>
    <div id="top">
      <div class="card-content" v-if="style === '0'">
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
        <h2>お問い合わせ</h2>
        <input type="text" placeholder="お名前" v-model="name" required>
        <input type="text" placeholder="メールアドレス" v-model="mail" required>
        <input type="tel" placeholder="お電話" v-model="tel">
        <textarea type="text" placeholder="お問い合わせ内容" v-model="content" required></textarea>
      <button id="send" @click="send">お問い合わせ</button>
      <!--<p>本サービスに関する<a href="#" style="color: #5D99FF;">利用規約</a>はこちらへ。</p>-->
      </div>

      <div class="card-content" v-else>
        <h1><img src="https://kirarin-covid19.com/img/siteid.png" ></h1>
        <h2>Contact</h2>
        <input type="text" placeholder="name" v-model="name" required>
        <input type="text" placeholder="mail" v-model="mail" required>
        <input type="tel" placeholder="tel" v-model="tel">
        <textarea type="text" placeholder="content" v-model="content" required></textarea>
      <button id="send" @click="send">Contact</button>
      <!--<p>Check out <a href="#" style="color: #5D99FF;">Policy</a> of this service</p>-->
      </div>
    </div>
    <Footer/>
  </div>
</template>
<style scoped>
#top img{width: 60%;margin-top: 5%;margin-bottom: 5%;}
#top{position: absolute;top: 50%;left: 50%;width: 30%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}

#top input{
  display: block;
  width: 90%;
  height: 40px;
  margin: 16px auto;
  font-size: 1em;
}

h1{
 margin: 0px;
}
body{
  margin: 0px;
}
#top #send{
display: block;
  width: 80%;
  line-height: 40px;
  height: 40px;
  margin: 8% auto;
  text-align: center;
  font-size: 1em;
  text-align: center;
  background: #5D99FF;
  text-transform: uppercase;
  text-decoration: none;
  color: white;
  border:0px;
  border-radius: 4px;
}

#top #login:hover{
  opacity: 0.7;
}
.card-content{
  padding:8px;
  width: 100%;
  height: auto;
  background-color: white;
  margin: 0 auto;
}
textarea{
  width: 90%;
  height: 5em;
}
@media screen and (max-width:780px) {
#top img{width: 80%;margin-top: 5%;margin-bottom: 5%;}
#top{position: absolute;top: 50%;left: 50%;width: 80%;transform: translateY(-50%) translateX(-50%);box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);}
.card-content p{font-size: .8em;}
h2{
  margin-top: 0px;
}
}
.select-os{
  text-align: end;
  margin-top: 2em;
  margin-right: 2em;
}
.select-os input {
  display: none;
}
.select-os input[type="radio"]:checked.japanese + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os input[type="radio"]:checked.english + label {
  color: #3275bc;
  border: 2px solid #3275bc;
  background-color: #d0e6fd;
}
.select-os label {
  color: #ddd;
  border: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  padding: 5px 0px;
  width: 120px;
}
.select-os label:hover {
    color: #aaa;
    border: 2px solid #aaa;
    cursor: pointer;
}

</style>
<script>
import $ from 'jquery'
import Loading from './common/Loading'
import Footer from './common/Footer'
import firebase from 'firebase'
export default {
  name: 'Login',
  components: {
    Loading, Footer
  },
  data () {
    return {
      db: null,
      loading: null,
      mail: null,
      name: null,
      tel: null,
      content: null,
      style: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    }
  },
  created: function () {
    this.db = firebase.firestore()
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.style = result['style']
  },
  methods: {
    send: function () {
      let self = this
      // ユーザー情報への登録有無を確認し、新規であれば登録、既存に登録されているのであればパスコードを更新する
      if (!this.name) {
        if (self.style === '0') {
          alert('お名前が入力されていません。')
        } else {
          alert('No name has been entered.Please try again.')
        }
        return
      }
      if (!this.mail) {
        if (self.style === '0') {
          alert('メールアドレスが入力されていません。')
        } else {
          alert('No email address has been entered.Please try again.')
        }
        return
      }
      // メールアドレスのバリデーション
      if (!this.mailPattern.test(this.mail)) {
        if (this.style === '0') {
            alert('メールアドレスの入力が正しくありません。')
        } else {
            alert('The email address is entered incorrectly.Please try again.')
        }
        return
      }
      if (!this.tel) {
        if (self.style === '0') {
          alert('電話番号が入力されてません。')
        } else {
          alert('No tel number has been entered.Please try again.')
        }
        return
      }
      var tel = this.tel.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi,'');
      if (!tel.match(/^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/)) {
        if (this.style === '0') {
            alert('電話番号の入力が正しくありません。')
            return
        } else {
            alert('The phone number is entered incorrectly.Please try again.')
            return
        }
      }
      if (!this.content) {
        if (self.style === '0') {
          alert('お問い合わせ内容が入力されていません。')
        } else {
          alert('No content has been entered.')
        }
        return
      }
      this.loading = true

      // Contactsデータベースへ内容を保存
      let collection = self.db.collection('contacts')
          var doc = {
              type: 0,
              company: null,
              institution: null,
              name: self.name,
              mail: self.mail,
              tel: self.tel,
              content: self.content,
              date: new Date()
          }
          collection.add(doc).then(function (docRef) {
            // メール送信
            // メール送信
            var data = { 'mail': self.mail, 'name': self.name, 'tel': self.tel, 'content': self.content }

             var url = null
            if (self.style === '0') {
                url = 'https://weart-marketing.com/api/contact/'
            } else {
                url = 'https://weart-marketing.com/api/contact/en/'
            }

            $.ajax({
              url: url,
              type: 'POST',
              data: data
            }).done(function (data) {
              if (self.style === '0') {
                   alert('送信完了。')
              } else {
                  alert('Message sent successfully.')
              }
            }).fail(function () {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
              } else {
                  alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
            })
            
              
          }).catch(function (error) {
              if (self.style === '0') {
                  alert('一時的なサーバーエラーが発生しました。')
              } else {
                  alert('System error has temporarily occurred.')
              }
              location.href = "/error?style=" + self.style
          })



      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue